import Vue from 'vue'

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Alert from 'vux/src/components/alert/index.vue'


import {
Dialog
} from 'vant';
Vue.use(Dialog);





Vue.use(ToastPlugin)


Vue.component('cell', Cell)
Vue.component('group', Group)
Vue.component('x-textarea', XTextarea)
Vue.component('view-box', ViewBox)
Vue.component('x-button', XButton)
Vue.component('badge', Badge)
Vue.component('loading', Loading)
Vue.component('x-dialog', XDialog)
Vue.component('popup', Popup)
Vue.component('checklist', Checklist)
Vue.component('popupPicker', PopupPicker)
Vue.component('alert', Alert)


// WEBPACK FOOTER //
// ./src/plugin/index.js